import { render, staticRenderFns } from "./information.vue?vue&type=template&id=e87a0ed2&scoped=true&"
import script from "./information.vue?vue&type=script&lang=ts&"
export * from "./information.vue?vue&type=script&lang=ts&"
import style0 from "./information.vue?vue&type=style&index=0&id=e87a0ed2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a0ed2",
  null
  
)

export default component.exports